module.exports = __webpack_public_path__ + "img/squad_join.93d68cd0.jpg";